import Swiper from "swiper/bundle";

// Makes Swiper available in Node.js global scope.
if (typeof global !== "undefined") global.Swiper = Swiper;
// Makes Swiper available in browser global scope.
if (typeof window !== "undefined") window.Swiper = Swiper;
